import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class ModifyJobbStatusCommand extends BasicCommand<ModifyJobbStatusCommand> {
    get primaryKey(): IPrimaryKey<ModifyJobbStatusCommand> {
        return {
            id: this.id
        };
    }
    id: number;
    jobbStatus: string;
    antalForsok?: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Jobb";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ModifyJobbStatusCommand";
    constructor(init: (instance: ModifyJobbStatusCommand) => void) {
        super(ModifyJobbStatusCommand.$type, ModifyJobbStatusCommand.$groupKey, CommandType.Delete);
        init(this);
    }
}
